// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitors-page .all-salons-note {
  margin: 0 0 10px;
}
.monitors-page .monitors-salons {
  display: grid;
  gap: 14px;
}
.monitors-page .monitor-salon-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.monitors-page .monitor-salon-heading h2 {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  overflow-wrap: anywhere;
}
.monitors-page .monitor-empty p {
  margin: 0;
}
.monitors-page .monitors-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}
.monitors-page .monitors-summary > div {
  display: grid;
  gap: 5px;
  border: 1px solid #e1e6ef;
  border-radius: 12px;
  background: white;
  padding: 12px;
  min-width: 0;
}
.monitors-page .monitors-summary span {
  font-size: 11px;
  line-height: 1.4;
  color: #78849a;
}
.monitors-page .monitors-summary b {
  font-size: 22px;
}
.monitors-page .monitors-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}
.monitors-page .monitor-point {
  margin-bottom: 0;
  align-self: start;
}
.monitors-page .monitor-point p, .monitors-page .monitor-point strong {
  overflow-wrap: anywhere;
}
.monitors-page .monitor-point-heading {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
}
.monitors-page .monitor-point-heading h3 {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 14px;
}
.monitors-page .monitor-point-heading .compact-badge {
  flex-shrink: 0;
  max-width: 90px;
  text-align: center;
  box-sizing: border-box;
}
.monitors-page .monitor-last-seen {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 12px;
}
.monitors-page .monitor-last-seen span {
  font-size: 11px;
  color: #78849a;
}
.monitors-page .monitor-last-seen strong {
  font-size: 12px;
}
.monitors-page .monitor-playlist {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  padding: 10px;
  background: #f5f7fb;
}
.monitors-page .monitor-playlist > svg {
  flex: 0 0 20px;
  width: 20px;
  color: #78849a;
}
.monitors-page .monitor-playlist > div {
  display: grid;
  gap: 4px;
  min-width: 0;
}
.monitors-page .monitor-playlist span {
  font-size: 10px;
  color: #78849a;
}
.monitors-page .monitor-playlist strong {
  font-size: 13px;
}
.monitors-page .monitor-devices, .monitors-page .monitor-info {
  border-top: 1px solid #edf0f5;
  margin-top: 8px;
}
.monitors-page .monitor-devices summary, .monitors-page .monitor-info summary {
  font-size: 12px;
  color: #6f7b92;
}
.monitors-page .monitor-device {
  padding: 10px 0;
  border-top: 1px solid #edf0f5;
}
.monitors-page .monitor-device .compact-heading {
  margin-bottom: 4px;
  flex-wrap: wrap;
}
.monitors-page .monitor-device .compact-heading strong {
  font-size: 13px;
}
.monitors-page .monitor-device .compact-heading span {
  font-size: 11px;
}
.monitors-page .monitor-device p {
  margin: 4px 0;
}
.monitors-page .monitors-explanation {
  font-size: 11px;
  margin: 0 0 12px;
}
.monitors-page .monitors-support {
  justify-self: start;
}
@media (max-width: 650px) {
  .monitors-page .monitors-list {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/MonitorsAdsPage/monitors.scss"],"names":[],"mappings":"AACE;EAAmB,gBAAA;AACrB;AAAE;EAAmB,aAAA;EAAe,SAAA;AAIpC;AAHE;EAAyB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,kBAAA;AASzE;AAT6F;EAAK,SAAA;EAAS,YAAA;EAAc,eAAA;EAAiB,gBAAA;EAAkB,SAAA;EAAW,uBAAA;AAiBvK;AAhBE;EAAmB,SAAA;AAmBrB;AAlBE;EAAoB,aAAA;EAAe,8BAAA;EAAgC,QAAA;EAAU,mBAAA;AAwB/E;AAxBoG;EAAQ,aAAA;EAAe,QAAA;EAAU,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,aAAA;EAAe,YAAA;AAiCvN;AAjCuO;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAsCjR;AAtCmS;EAAI,eAAA;AAyCvS;AAxCE;EAAiB,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,mBAAA;AA8C/F;AA7CE;EAAiB,gBAAA;EAAkB,iBAAA;AAiDrC;AAjDwD;EAAY,uBAAA;AAoDpE;AAnDE;EAAyB,aAAA;EAAe,uBAAA;EAAyB,QAAA;EAAU,mBAAA;AAyD7E;AAzDkG;EAAK,SAAA;EAAS,YAAA;EAAc,SAAA;EAAW,uBAAA;EAAyB,eAAA;AAgElK;AAhEqL;EAAiB,cAAA;EAAgB,eAAA;EAAiB,kBAAA;EAAoB,sBAAA;AAsE3P;AArEE;EAAqB,aAAA;EAAe,eAAA;EAAiB,8BAAA;EAAgC,QAAA;EAAU,mBAAA;AA4EjG;AA5EsH;EAAO,eAAA;EAAiB,cAAA;AAgF9I;AAhFgK;EAAS,eAAA;AAmFzK;AAlFE;EAAoB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AA0FzG;AA1F8H;EAAQ,cAAA;EAAgB,WAAA;EAAa,cAAA;AA+FnK;AA/FqL;EAAQ,aAAA;EAAe,QAAA;EAAU,YAAA;AAoGtN;AApGsO;EAAO,eAAA;EAAiB,cAAA;AAwG9P;AAxGgR;EAAS,eAAA;AA2GzR;AA1GE;EAAkC,6BAAA;EAA+B,eAAA;AA8GnE;AA9GoF;EAAU,eAAA;EAAiB,cAAA;AAkH/G;AAjHE;EAAkB,eAAA;EAAiB,6BAAA;AAqHrC;AArHoE;EAAmB,kBAAA;EAAoB,eAAA;AAyH3G;AAzH4H;EAAS,eAAA;AA4HrI;AA5HwJ;EAAO,eAAA;AA+H/J;AA/HoL;EAAI,aAAA;AAkIxL;AAjIE;EAAwB,eAAA;EAAiB,gBAAA;AAqI3C;AApIE;EAAoB,mBAAA;AAuItB;AAtIE;EAA4B;IAAiB,qCAAA;EA0I7C;AACF","sourcesContent":[".monitors-page {\n  .all-salons-note { margin: 0 0 10px; }\n  .monitors-salons { display: grid; gap: 14px; }\n  .monitor-salon-heading { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; h2 { flex: 1; min-width: 0; font-size: 14px; line-height: 1.4; margin: 0; overflow-wrap: anywhere; } }\n  .monitor-empty p { margin: 0; }\n  .monitors-summary { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 10px; > div { display: grid; gap: 5px; border: 1px solid #e1e6ef; border-radius: 12px; background: white; padding: 12px; min-width: 0; } span { font-size: 11px; line-height: 1.4; color: #78849a; } b { font-size: 22px; } }\n  .monitors-list { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-bottom: 10px; }\n  .monitor-point { margin-bottom: 0; align-self: start; p, strong { overflow-wrap: anywhere; } }\n  .monitor-point-heading { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 12px; h3 { flex: 1; min-width: 0; margin: 0; overflow-wrap: anywhere; font-size: 14px; } .compact-badge { flex-shrink: 0; max-width: 90px; text-align: center; box-sizing: border-box; } }\n  .monitor-last-seen { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 6px; margin-bottom: 12px; span { font-size: 11px; color: #78849a; } strong { font-size: 12px; } }\n  .monitor-playlist { display: flex; align-items: center; gap: 10px; border-radius: 10px; padding: 10px; background: #f5f7fb; > svg { flex: 0 0 20px; width: 20px; color: #78849a; } > div { display: grid; gap: 4px; min-width: 0; } span { font-size: 10px; color: #78849a; } strong { font-size: 13px; } }\n  .monitor-devices, .monitor-info { border-top: 1px solid #edf0f5; margin-top: 8px; summary { font-size: 12px; color: #6f7b92; } }\n  .monitor-device { padding: 10px 0; border-top: 1px solid #edf0f5; .compact-heading { margin-bottom: 4px; flex-wrap: wrap; strong { font-size: 13px; } span { font-size: 11px; } } p { margin: 4px 0; } }\n  .monitors-explanation { font-size: 11px; margin: 0 0 12px; }\n  .monitors-support { justify-self: start; }\n  @media (max-width: 650px) { .monitors-list { grid-template-columns: minmax(0, 1fr); } }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
